// NOTE: ChainId, ChainName, Chain reference table: https://chainid.network/

const {
    REACT_APP_RPC_URL_ETH,
    REACT_APP_RPC_URL_RINKEBY,
    REACT_APP_RPC_URL_OPTIMISTIC_ETHEREUM,
    REACT_APP_RPC_URL_OPTIMISTIC_ETHEREUM_TESTNET_KOVAN,
} = process.env

interface IChains {
    [chainId: number]: {
        name: string
        aliasName?: string
        rpc: string[]
    }
}

function normalizeRpcString(rpc: string): string[] {
    return rpc.split(",")
}

export enum ChainId {
    ETHEREUM = 1,
    RINKEBY = 4,
    OPTIMISTIC_ETHEREUM = 10,
    OPTIMISTIC_ETHEREUM_TESTNET_KOVAN = 69,
}


export const CHAINS: IChains = {
    [ChainId.ETHEREUM]: {
        name: "Ethereum",
        rpc: normalizeRpcString(REACT_APP_RPC_URL_ETH || ""),
    },
    [ChainId.RINKEBY]: {
        name: "Rinkeby",
        // NOTE: will remove this rate-limit rpc endpoints later and add more rpc url here
        rpc: normalizeRpcString(REACT_APP_RPC_URL_RINKEBY || ""),
    },
    [ChainId.OPTIMISTIC_ETHEREUM]: {
        name: "Optimistic Ethereum",
        aliasName: "Optimistic",
        rpc: normalizeRpcString(REACT_APP_RPC_URL_OPTIMISTIC_ETHEREUM || ""),
    },
    [ChainId.OPTIMISTIC_ETHEREUM_TESTNET_KOVAN]: {
        name: "Optimistic Ethereum Testnet Kovan",
        aliasName: "OptimisticKovan",
        rpc: normalizeRpcString(REACT_APP_RPC_URL_OPTIMISTIC_ETHEREUM_TESTNET_KOVAN || ""),
    },
}
